// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'case-medical';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.656 4.464h14.616c.648 0 1.152.504 1.152 1.152v10.152c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V5.616c.072-.648.576-1.152 1.152-1.152z' />
    <path d='M11.52 1.872c-.144-.432-.576-.792-1.08-.792H7.56c-.504.072-.936.36-1.08.792l-.864 2.592h6.768zM2.808 4.464v-1.08m12.384 1.08v-1.08m-3.384 7.56H6.192M9 8.136v5.616' />
  </g>
);

export const viewBox = '0 0 18 18';
